module.exports = __webpack_public_path__ + "static/chirpyestLogo-264ea8c7907fa0add56439f6f7c21d53.svg";